import * as R from 'ramda';
import React from 'react';
import classnames from 'classnames';
import { string } from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  MDCLineRippleFoundation,
} from '@material/line-ripple/dist/mdc.lineRipple';

class LineRipple extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      classes: [],
    };

    // this.onAutoFillStart = this.onAutoFillStart.bind(this);
    this.foundation = new MDCLineRippleFoundation({
      addClass: (className) => {
        this.setState(({ classes }) => ({
          classes: R.append(className, classes),
        }));
      },
      removeClass: (className) => {
        this.setState(({ classes }) => ({
          classes: R.reject(R.equals(className), classes),
        }));
      },
      setAttr: (attr, value) => this.root && this.root.setAttribute(attr, value),
      registerEventHandler: (evtType, handler) =>
        this.root.addEventListener(evtType, handler),
      deregisterEventHandler: (evtType, handler) =>
        this.root.removeEventListener(evtType, handler),
      notifyAnimationEnd: () => null,
    });
  }

  componentDidMount() {
    this.foundation.init();
  }

  componentWillUnmount() {
    this.foundation.destroy();
  }


  render() {
    const { className } = this.props;
    const { classes } = this.state;

    return (
      <div
        ref={(element) => { this.root = element; }}
        className={classnames(
          'mdc-line-ripple',
          className,
          ...classes,
        )}
      />
    );
  }
}

LineRipple.propTypes = {
  className: string,
};

LineRipple.defaultProps = {
  className: undefined,
};

export default LineRipple;
